module.exports = "<div fxFlexFill fxLayoutAlign=\"center center\">\n  <mat-icon>arrow_drop_down</mat-icon>\n</div>\n"